import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { Ref } from 'react';
import { forwardRef, memo } from 'react';

export type DoubleCheckIconProps = SvgIconProps & {
  firstColor?: string;
  secondColor?: string;
};

function DoubleCheckIconComponent(
  {
    firstColor = 'currentColor',
    secondColor = 'currentColor',
    ...props
  }: DoubleCheckIconProps,
  ref: Ref<SVGSVGElement>,
) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        fill={firstColor}
        d="M5.72153 18L0 12.2962L1.75907 10.5428L5.72153 14.493L14.2409 6L16 7.75339L5.72153 18Z"
      />
      <path
        fill={secondColor}
        d="M13.8849 18L11 15.0775L12.7311 13.3241L13.8849 14.493L22.2689 6L24 7.75339L13.8849 18Z"
      />
    </SvgIcon>
  );
}

DoubleCheckIconComponent.displayName = 'DoubleCheckIcon';

const DoubleCheckIcon = memo(forwardRef(DoubleCheckIconComponent));

export default DoubleCheckIcon;
